<mat-card appearance="outlined">
  <mat-card-header>
    <img mat-card-avatar class="accessory-box-img"
      [src]="'/files/windowsill/' + accessory?.image"
      [alt]="accessory?.name"
      defaultImg>
      <mat-card-title class="accessory-box-title">{{accessory?.name}}
      </mat-card-title>
      <mat-card-subtitle class="accessory-box-description">
      {{accessory?.description}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form">
        @if (accessory.pricing_data[0]?.colors.length > 0) {
          <mat-form-field>
            <mat-label>{{ 'WINDOWSILL|Kolor:' | translate }}</mat-label>
            <mat-select formControlName="selectedColor">
              @for (color of accessory.colors_pricing; track color; let id = $index) {
                <mat-option
                  [value]="id">
                  {{color.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (accessory.plugs_data.length > 0) {
          <mat-form-field>
            <mat-label>{{ 'WINDOWSILL|Zaślepki PCV:' | translate }}</mat-label>
            <mat-select formControlName="plugs">
              <mat-option [value]="0">{{ 'INTERFACE|Brak' | translate}}</mat-option>
              <mat-option [value]="1">{{ 'WINDOWSILL|Standard' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        }
        @if (['raster', 'standard', 'm2'].includes(accessory.pricing_type)) {
          <mat-form-field>
            <mat-label>{{ 'WINDOWSILL|Szerokość' | translate }}</mat-label>
            @if (accessory.in_range || accessory.pricing_type !== 'standard') {
              <input matInput iccDimensionInput formControlName="currentWidth"
                type="number"
                >
            }
            @if (!accessory.in_range && accessory.pricing_type === 'standard') {
              <mat-select formControlName="currentWidth">
                @for (width of getSillWidths(accessory); track width) {
                  <mat-option [value]="width * 1">{{  width |unitmm:0:0 }}</mat-option>
                }
              </mat-select>
            }
            <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
          </mat-form-field>
        }
        @if (accessory.max_length > 0) {
          <mat-form-field>
            <mat-label>{{ 'WINDOWSILL|Długość' | translate }}</mat-label>
            @if (accessory.in_range || accessory.pricing_type !== 'standard') {
              <input matInput iccDimensionInput formControlName="currentLength"
                type="number"
                >
            }
            @if (!accessory.in_range && accessory.pricing_type === 'standard') {
              <mat-select formControlName="currentLength">
                @for (length of getSillLengths(accessory); track length) {
                  <mat-option [value]="length * 1">{{  length |unitmm:0:0 }}</mat-option>
                }
              </mat-select>
            }
            <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
          </mat-form-field>
        }
        @if (['standard'].includes(accessory.pricing_type)) {
          <mat-checkbox formControlName="in_range" (change)="setInRange(accessory)">{{ 'WINDOWSILL|Wymiary niestandardowe' | translate }}</mat-checkbox>
        }

        @if (accessory.addons_data.length > 0) {
          <div class="accesoryBottom">
            <h5>{{ 'WINDOWSILL|Dodatki' | translate }}</h5>
            @for (addon of accessory.addons_data; track addon) {
              <mat-checkbox  ng-model="addon.selected">{{addon.name}}</mat-checkbox>
            }
          </div>
        }
        <mat-form-field>
          <input matInput type="number" min="1"
            [placeholder]="'WINDOWSILL|Ilość' | translate"
            formControlName="count">
          </mat-form-field>
          <mat-form-field>
            <input matInput type="text" formControlName="comment"
              [placeholder]="'INTERFACE|Komentarz' | translate">
            </mat-form-field>
            <h4>{{ 'CONFIGURATOR|Cena' | translate }}:
            {{ currentPrice$ | async | currency : currency }}</h4>
          </form>
        </mat-card-content>
        <mat-card-actions>
          @if (canAdd()) {
            <button mat-raised-button color="primary" (click)="add()"
            >{{ 'INTERFACE|Dodaj' | translate }}</button>
          }
        </mat-card-actions>


      </mat-card>
